import { LabelledRadioGroup } from '../LabelledRadioGroup/LabelledRadioGroup';
import { MonthlyRepeatFields } from './MonthlyRepeatFields';
import { SCHEDULER_LABEL_CLASS, SCHEDULER_SELECT_CLASS } from './schedulerFieldClasses';
import { Frequency, ParsedScheduleRule, ScheduleForm, WEEKDAYS } from './scheduleRule';

const INTERVAL_OPTIONS: Record<Frequency, { label: string; value: number }[]> = {
  daily: [1, 2, 3, 4, 5, 6].map((n) => ({ label: n === 1 ? 'Every Day' : `Every ${n} Days`, value: n })),
  weekly: [1, 2, 3].map((n) => ({ label: n === 1 ? 'Once a Week' : `Every ${n} Weeks`, value: n })),
  monthly: [1, 2, 3, 4, 5, 6].map((n) => ({ label: n === 1 ? 'Once a Month' : `Every ${n} Months`, value: n }))
};

export interface ScheduleCadenceFieldsProps {
  viewKey: string;
  cadence: ParsedScheduleRule;
  form: ScheduleForm;
  /** The saved schedule's cadence, for the day a monthly one repeats on; null for a new schedule. */
  savedCadence: ParsedScheduleRule | null;
  disabled: boolean;
  onCadenceChange: (patch: Partial<ParsedScheduleRule>) => void;
}

/** Frequency and interval, plus the weekday a weekly schedule sends on or the day a monthly one repeats on. */
export const ScheduleCadenceFields = ({
  viewKey,
  cadence,
  form,
  savedCadence,
  disabled,
  onCadenceChange
}: ScheduleCadenceFieldsProps) => {
  return (
    <>
      <div className="mb-3">
        <label
          htmlFor={`frequency-${viewKey}`}
          className={SCHEDULER_LABEL_CLASS}>
          Frequency
        </label>
        <div className="flex flex-wrap gap-3">
          <select
            id={`frequency-${viewKey}`}
            className={SCHEDULER_SELECT_CLASS}
            style={{ minWidth: 140 }}
            value={cadence.frequency}
            disabled={disabled}
            onChange={(e) => onCadenceChange({ frequency: e.target.value as Frequency, interval: 1 })}>
            <option value="daily">Daily</option>
            <option value="weekly">Weekly</option>
            <option value="monthly">Monthly</option>
          </select>
          <select
            aria-label="Interval"
            className={SCHEDULER_SELECT_CLASS}
            style={{ minWidth: 160 }}
            value={cadence.interval}
            disabled={disabled}
            onChange={(e) => onCadenceChange({ interval: Number(e.target.value) })}>
            {INTERVAL_OPTIONS[cadence.frequency].map((opt) => (
              <option
                key={opt.value}
                value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      {cadence.frequency === 'weekly' && (
        <div className="mb-3">
          <LabelledRadioGroup
            label="Send on"
            name={`weekday-${viewKey}`}
            options={WEEKDAYS}
            value={cadence.weekday}
            disabled={disabled}
            onChange={(weekday) => onCadenceChange({ weekday })}
          />
        </div>
      )}

      {cadence.frequency === 'monthly' && (
        <MonthlyRepeatFields
          viewKey={viewKey}
          form={form}
          saved={savedCadence}
          disabled={disabled}
          onChange={onCadenceChange}
        />
      )}
    </>
  );
};
